import { GuidedTourPopover } from '../../components/GuidedTour/GuidedTourPopover.tsx';
import { useFTUX } from '../../controller/hooks/useFTUX.ts';

export const AnalysisGuidedTour = () => {
  const { ftux: analysisFtux, dismiss: analysisDismiss } = useFTUX('analysisIntroTour');

  return <GuidedTourPopover tourID="analysisTour" ftux={analysisFtux} dismiss={analysisDismiss} />;
};
